import React, { useEffect } from 'react';

const MagicCursor = () => {
  useEffect(() => {
    const outline = document.querySelector('.outline');
    const cursor = document.querySelector('.cursor');
    const links = document.querySelectorAll('a, button');

    const handleMouseMove = (e) => {
      const x = e.clientX;
      const y = e.clientY;
      
      if (outline) {
        outline.style.transform = `translate(calc(${x}px - 50%), calc(${y}px - 50%))`;
      }
      
      if (cursor) {
        cursor.style.left = x + 'px';
        cursor.style.top = y + 'px';
      }
    };

    const handleMouseOver = () => {
      outline?.classList.add('hover');
    };

    const handleMouseLeave = () => {
      outline?.classList.remove('hover');
    };

    document.addEventListener('mousemove', handleMouseMove);
    
    links.forEach(link => {
      link.addEventListener('mouseover', handleMouseOver);
      link.addEventListener('mouseleave', handleMouseLeave);
    });

    return () => {
      document.removeEventListener('mousemove', handleMouseMove);
      links.forEach(link => {
        link.removeEventListener('mouseover', handleMouseOver);
        link.removeEventListener('mouseleave', handleMouseLeave);
      });
    };
  }, []);

  return (
    <>
      <div className="outline"></div>
      <div className="cursor"></div>
    </>
  );
};

export default MagicCursor;
